import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const SalesTeamInfo = () => {
  const salesTeam = [
    {
      id: 1,
      name: "Sarah Chen",
      role: "Enterprise Sales Director",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
      specialties: ["Enterprise Solutions", "Technical Architecture", "Compliance"],
      email: "sarah.chen@messaginghub.pro",
      phone: "+1 (555) 123-4567",
      timezone: "PST (UTC-8)"
    },
    {
      id: 2,
      name: "Marcus Rodriguez",
      role: "Solutions Engineer",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      specialties: ["API Integration", "SDK Support", "Technical Demos"],
      email: "marcus.rodriguez@messaginghub.pro",
      phone: "+1 (555) 234-5678",
      timezone: "EST (UTC-5)"
    }
  ];

  const responseCommitments = [
    {
      icon: "Clock",
      title: "2-Hour Response",
      description: "Initial response within 2 business hours"
    },
    {
      icon: "Calendar",
      title: "Same-Day Demos",
      description: "Technical demos available same day"
    },
    {
      icon: "Shield",
      title: "Enterprise Support",
      description: "Dedicated support throughout evaluation"
    },
    {
      icon: "Zap",
      title: "Fast Implementation",
      description: "Get started in under 24 hours"
    }
  ];

  const availableSlots = [
    { time: "9:00 AM", available: true },
    { time: "10:30 AM", available: true },
    { time: "1:00 PM", available: false },
    { time: "2:30 PM", available: true },
    { time: "4:00 PM", available: true }
  ];

  return (
    <div className="space-y-6">
      {/* Sales Team */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Users" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Your Sales Team</h3>
        </div>
        
        <div className="space-y-4">
          {salesTeam?.map((member) => (
            <div key={member?.id} className="flex items-start space-x-4 p-4 bg-muted/30 rounded-lg">
              <div className="flex-shrink-0">
                <Image
                  src={member?.avatar}
                  alt={member?.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground">{member?.name}</h4>
                <p className="text-xs text-muted-foreground mb-2">{member?.role}</p>
                <div className="flex flex-wrap gap-1 mb-2">
                  {member?.specialties?.map((specialty, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-primary/10 text-primary"
                    >
                      {specialty}
                    </span>
                  ))}
                </div>
                <div className="space-y-1">
                  <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                    <Icon name="Mail" size={12} />
                    <span>{member?.email}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                    <Icon name="Phone" size={12} />
                    <span>{member?.phone}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                    <Icon name="Globe" size={12} />
                    <span>{member?.timezone}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Response Commitments */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="CheckCircle" size={20} className="text-accent" />
          <h3 className="text-lg font-semibold text-foreground">Our Commitments</h3>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {responseCommitments?.map((commitment, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={commitment?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground">{commitment?.title}</h4>
                <p className="text-xs text-muted-foreground">{commitment?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Quick Demo Scheduling */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Video" size={20} className="text-secondary" />
          <h3 className="text-lg font-semibold text-foreground">Schedule a Demo</h3>
        </div>
        
        <p className="text-sm text-muted-foreground mb-4">
          Available today for 30-minute technical demos
        </p>
        
        <div className="space-y-2 mb-4">
          {availableSlots?.map((slot, index) => (
            <div
              key={index}
              className={`flex items-center justify-between p-3 rounded-lg border ${
                slot?.available
                  ? 'border-border bg-muted/20 hover:bg-muted/40 cursor-pointer' :'border-border bg-muted/10 opacity-50'
              }`}
            >
              <div className="flex items-center space-x-2">
                <Icon 
                  name={slot?.available ? "Clock" : "X"} 
                  size={16} 
                  className={slot?.available ? "text-accent" : "text-muted-foreground"} 
                />
                <span className="text-sm text-foreground">{slot?.time} PST</span>
              </div>
              <span className={`text-xs ${
                slot?.available ? "text-accent" : "text-muted-foreground"
              }`}>
                {slot?.available ? "Available" : "Booked"}
              </span>
            </div>
          ))}
        </div>
        
        <Button
          variant="outline"
          size="sm"
          fullWidth
          iconName="Calendar"
          iconPosition="left"
        >
          View All Available Times
        </Button>
      </div>
      {/* Contact Methods */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="MessageSquare" size={20} className="text-warning" />
          <h3 className="text-lg font-semibold text-foreground">Other Ways to Reach Us</h3>
        </div>
        
        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 bg-muted/20 rounded-lg">
            <div className="flex items-center space-x-3">
              <Icon name="Phone" size={16} className="text-primary" />
              <div>
                <p className="text-sm font-medium text-foreground">Sales Hotline</p>
                <p className="text-xs text-muted-foreground">+1 (800) MSG-HUBS</p>
              </div>
            </div>
            <Button variant="ghost" size="sm" iconName="ExternalLink">
              Call
            </Button>
          </div>
          
          <div className="flex items-center justify-between p-3 bg-muted/20 rounded-lg">
            <div className="flex items-center space-x-3">
              <Icon name="MessageCircle" size={16} className="text-accent" />
              <div>
                <p className="text-sm font-medium text-foreground">Live Chat</p>
                <p className="text-xs text-muted-foreground">Available 9 AM - 6 PM PST</p>
              </div>
            </div>
            <Button variant="ghost" size="sm" iconName="MessageCircle">
              Chat
            </Button>
          </div>
          
          <div className="flex items-center justify-between p-3 bg-muted/20 rounded-lg">
            <div className="flex items-center space-x-3">
              <Icon name="Mail" size={16} className="text-secondary" />
              <div>
                <p className="text-sm font-medium text-foreground">Email Sales</p>
                <p className="text-xs text-muted-foreground">sales@messaginghub.pro</p>
              </div>
            </div>
            <Button variant="ghost" size="sm" iconName="ExternalLink">
              Email
            </Button>
          </div>
        </div>
      </div>
      {/* Trust Signals */}
      <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Award" size={20} className="text-warning" />
          <h3 className="text-lg font-semibold text-foreground">Why Choose Us</h3>
        </div>
        
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <Icon name="Shield" size={16} className="text-accent" />
            <span className="text-sm text-foreground">SOC 2 Type II Certified</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="Zap" size={16} className="text-primary" />
            <span className="text-sm text-foreground">99.9% Uptime SLA</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="Users" size={16} className="text-secondary" />
            <span className="text-sm text-foreground">500+ Enterprise Customers</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="Globe" size={16} className="text-warning" />
            <span className="text-sm text-foreground">Global Infrastructure</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesTeamInfo;